import styled, { keyframes, css } from 'styled-components';
import { COLORS } from './../../ui';

interface Props {
  width?: string;
  height?: string;
}

const Shimmer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
`;

const placeholderShimmer = keyframes`
  from {
    background-position: -468px 0;
  }

  to {
    background-position: 468px 0;
  }
`;

const styles = css`
  display: block;
  max-width: 100%;
  box-sizing: border-box;
  background: ${COLORS.HOVER_GRAY};
  background-image: linear-gradient(to right, ${COLORS.HOVER_GRAY} 0%, ${COLORS.LIGHT_GRAY} 20%, ${COLORS.HOVER_GRAY} 40%, ${COLORS.HOVER_GRAY} 100%);
  background-repeat: no-repeat;
  background-size: 800px 100%;
  position: relative;
  border-radius: 5px;

  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: ${placeholderShimmer};
  animation-timing-function: linear;
`;

const Line = styled.div`
  width: ${(props: Props) => props.width || '260px'};
  height: ${(props: Props) => props.height || '18px'};
  ${styles}
`;

const Photo = styled.div`
  width: ${(props: Props) => props.width || '60px'};
  height: ${(props: Props) => props.width || '60px'};
  ${styles}
`

Shimmer.Line = Line;
Shimmer.Photo = Photo;

export { Shimmer };
